// Ladakh trip data — exact content from theunexploredroutes.com
const ladakhTrip = {
  _id: '1',
  title: 'Ladakh Adventure Trek',
  destination: 'Leh, Nubra Valley & Pangong Lake, Ladakh',
  description: 'LADAKH — The Land of High Passes. Arrive at Kushok Bakula Airport Leh at 3500m above sea level. One of the most dramatic landscapes on Earth — barren mountains, turquoise rivers, ancient Buddhist monasteries, and the world\'s highest motorable road. This is Ladakh.',
  duration: '7N/8D',
  price: 18999,
  originalPrice: 22000,
  maxGroupSize: 12,
  difficulty: 'Challenging',
  category: 'Adventure',
  coverImage: '/ladakh.jpg',
  rating: 4.9,
  reviewCount: 45,
  featured: true,
  highlights: [
    'Khardungla Pass — Highest Motorable Road in the World (18,380 ft)',
    'Pangong Lake — Highest Land-Locked Lake (14,000 ft / 4,267m)',
    'Turtuk Village — Last Village of India near Line of Control',
    'Diskit Monastery & Camel Safari in Sand Dunes, Nubra Valley',
    'Indus & Zanskar River Sangam, Magnetic Hill',
    'Pathar Sahib Gurdwara, Spituk Monastery, Hall of Fame',
    'Thiksey Monastery — Return via Leh',
  ],
  itinerary: [
    {
      day: 1,
      title: 'Day 01 — Arrive at Leh Airport (3505 meters / 11567 feet)',
      description: 'Arrive at Kushok Bakula Airport Leh — 3500m above sea level. Transfer to hotel. Half Day at rest for acclimatization. Rest of the day is at leisure. Hire a bike and explore Leh market, Ladakhi cuisine and much more.\n\nOvernight stay in guest house / homestay / hotel.',
      accommodation: 'Hotel/Guesthouse/Homestay in Leh',
      meals: 'Dinner',
      image: '/ladakh.jpg',
    },
    {
      day: 2,
      title: 'Day 02 — Sham Valley Tour',
      description: 'After breakfast leave for the full day sightseeing of Indus & Zanskar River Sangam, drive along the Indus river visiting Pathar Sahib Gurdwara and Magnetic Hill (where the cars defy gravity), Spituk Monastery (The site of Spituk was blessed by the Arhat Nyimagung) and Hall of Fame (which has a museum of the Kargil War memorabilia). Visit Shanty Stupa and Leh Palace.\n\nDinner and Overnight at the Hotel/Guest house/Homestay in Leh.',
      accommodation: 'Hotel/Guesthouse/Homestay in Leh',
      meals: 'Breakfast & Dinner',
      image: 'https://images.pexels.com/photos/3408353/pexels-photo-3408353.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop',
    },
    {
      day: 3,
      title: 'Day 03 — Leh to Khardungla Pass (18380 Ft) to Nubra Valley and Hundur (130 Kms, 4/5 Hrs)',
      description: 'After Breakfast drive to Nubra Valley via Khardungla (Highest Motorable road in the World, 18,380 ft). Arrive at Hundur by Afternoon. Rest of the day, Post lunch free to explore Diskit Monastery, Hunder Villages and camel Safari in Sand Dunes between Deskit and Hunder Village.\n\nOvernight stay at the Guest house/homestay/hotel/camp.',
      accommodation: 'Guest house/Homestay/Camp in Nubra Valley',
      meals: 'Breakfast & Dinner',
      image: 'https://images.pexels.com/photos/4534200/pexels-photo-4534200.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop',
    },
    {
      day: 4,
      title: 'Day 04 — Nubra/Hunder Nubra to Turtuk and back to Hunder/Nubra (90 km — Last Village of India)',
      description: 'Morning After Breakfast Leave from Nubra Valley towards Turtuk Village. A remote village of about 4,000 residents, inhabited by ethnic Muslims, a few kilometres from the line of control (the de facto border) between India and Pakistan on the Indian side. Until 1971 a part of Baltistan, shared strong economic and cultural ties with Tibet. The residents speak Baltistani, and some Ladakhi and English.\n\nAnd Late Return Back To Nubra Valley for Night Stay.',
      accommodation: 'Guest house/Homestay/Camp in Nubra Valley',
      meals: 'Breakfast & Dinner',
      image: '/ladakh.jpg',
    },
    {
      day: 5,
      title: 'Day 05 — Nubra Valley to Pangong Lake — Highest Land Locked Lake (180 Kms on way from Leh, 6/8 Hrs)',
      description: 'Early Morning after breakfast we leave for Pangong Lake through Changla pass 5486 Mtrs. via Wari La/Shyok Route. Pangong Lake, situated at 14,000 feet (4,267 m). A long narrow basin of inland drainage, hardly six to seven kilometres at its widest point and over 130km long, it is bisected by the international border between India and China.\n\nA few years back the government decided to open it to tourists though the lake and its surrounding is under army surveillance. Enjoy the landscape in the back drop of the Lake. One rarely feels so close to nature and environment and the scenery is unforgettable.\n\nOvernight stay at the camp/hotel/homestay/guesthouse.',
      accommodation: 'Camp/Hotel/Homestay at Pangong Lake',
      meals: 'Breakfast & Dinner',
      image: 'https://images.pexels.com/photos/3408353/pexels-photo-3408353.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop',
    },
    {
      day: 6,
      title: 'Day 06 — Pangong Lake to Leh (150 Kms, 5 Hrs Drive)',
      description: 'After Breakfast drive back to Leh. En-route Visit Thiksey Monastery. Later Walk around Leh Market.\n\nOvernight stay at Hotel/Guest house/Homestay.',
      accommodation: 'Hotel/Guest house/Homestay in Leh',
      meals: 'Breakfast & Dinner',
      image: '/ladakh.jpg',
    },
    {
      day: 7,
      title: 'Day 07 — Depart Leh — Kushok Bakula Airport',
      description: 'Morning after breakfast, transfer to airport. Board your flight towards Destination Covered, to enjoy yet again, a beautiful flight over the great Himalayas.',
      accommodation: '-',
      meals: 'Breakfast',
      image: '/ladakh.jpg',
    },
  ],
  inclusions: [
    'Accommodation on Double/triple sharing',
    'Breakfast and dinner',
    '03 Nights stay at Leh Ladakh',
    '02 Night Stay at Nubra Valley',
    '01 Night Stay at Pangong Lake',
    'Transfer and Sightseeing as per the below tour Itinerary by Non a/c Tempo Traveller',
    'Inner Line Permits and wild life fee',
    'Environmental fee',
    'Toll Taxes, Parkings, Driver allowances',
  ],
  exclusions: [
    'Any sightseeing or excursion that is not mentioned in the itinerary',
    'Monument, Guide, other expenses not mentioned in inclusion',
    'Any item of personal requirement, such as drinks, laundry, telephone, etc.',
    'Any medical or evacuation expenses',
    'Any expenses occur due to natural climate, security and other unexpected reason',
    'Any claim due to road blocks, curfew, accident etc.',
    'Any type of insurance — personal, medical, travel etc.',
    'Any other services not specified in the Column "Inclusions"',
    'All kind of personal expenses such as tips, laundry, telephone bills and beverages, Camera Fees',
    'Cable Car Tickets, Air Fare, Any meals unless and otherwise specifically mentioned',
    'No refund on any unused transportation or any services in any circumstances',
    'GST @ 5%',
  ],
  paymentTerms: [
    '50% Advance to confirm the reservation',
    'Balance 50% Payment before Departure of Trip at Leh',
  ],
  greeting: 'Dear Sir/Mam, Greetings from The Unexplored Routes!!! Thank you for providing me the opportunity for your holiday plans. I am pleased to attach suggested programme along with our very competitive price. I hope you like it. Best Regards, Manik Punjabi — The Unexplored Routes — 8109849232',
};

export default ladakhTrip;
